import { fetchDashboardClient } from 'legacy/apollo/dashboardClient'
import { ApolloError } from 'apollo-client'
import {
  FetchDepartmentsAndAislesItemsMeshDocument,
  type FetchDepartmentsAndAislesItemsMeshQuery,
  type FetchDepartmentsAndAislesItemsMeshQueryVariables,
} from '__codegen__/api'

/**
 * Fetches Items from a given aisle or department, depending on the passed variables
 *
 * @param variables
 * @returns
 */

export const fetchMeshAisleItems = async (
  variables: FetchDepartmentsAndAislesItemsMeshQueryVariables
) => {
  const client = fetchDashboardClient()

  const result = await client.query<
    FetchDepartmentsAndAislesItemsMeshQuery,
    FetchDepartmentsAndAislesItemsMeshQueryVariables
  >({ query: FetchDepartmentsAndAislesItemsMeshDocument, variables })

  if (result.errors) {
    throw new ApolloError({
      graphQLErrors: result.errors,
      errorMessage: 'Error when fetching Items from mesh',
    })
  }

  return result.data.retailerToolsServiceGetItems
}
